import React from "react";
import { useLocation } from "react-router-dom";
import { AuthManager } from "services/auth-service/auth";
import { useAppDispatch, useAppSelector } from "store";
import { sandboxActionInvoked, selectCurrentUser } from "store/features";
import { User } from "types/codeshareUser";
import { Avatar, Button, DropdownMenu, getUserColor, IconButton, MenuDivider, MenuExtraContent, MenuItem, Text } from "@itwin/itwinui-react";

export const UserAvatarButton = () => {
  const location = useLocation();
  const dispatch = useAppDispatch()
  const sandboxUser = useAppSelector((state) => state.auth.sandboxUser);
  const user = useAppSelector(selectCurrentUser);

  const avatarMenuItems = (close: () => void) => [
    <MenuExtraContent key={0}>
      {sandboxUser && <Text variant='leading'>{sandboxUser.username}</Text>}
      <Text isMuted style={{ marginBottom: 8 }}>
        {user?.name}
      </Text>
    </MenuExtraContent>,
    <MenuDivider key={1} />,
    sandboxUser
      ? <React.Fragment key={2}></React.Fragment>
      : <MenuItem
        key={2}
        onClick={() => { dispatch(sandboxActionInvoked({ type: "set-username" })); close(); }}
      >
        Set Sandbox User Name
      </MenuItem>,
    <MenuItem
      key={3}
      onClick={() => { AuthManager.openUserProfile(); close(); }}
    >
      View profile
    </MenuItem>,
    <MenuItem
      key={4}
      onClick={() => { AuthManager.signOut(); close(); }}
      data-testid="atp-signout-btn"
    >
      Sign out
    </MenuItem>,
  ];

  if (!user)
    return <Button data-testid="atp-signin-btn" size="small" styleType="borderless" onClick={() => AuthManager.signIn({ redirect: location.pathname })}> Sign In</Button >

  return (<DropdownMenu key="avatar" menuItems={avatarMenuItems}>
    <IconButton styleType="borderless" data-testid="atp-user-btn">
      <Avatar
        size="small"
        abbreviation={getAbbreviation(user)}
        backgroundColor={getUserColor(user.name || "SB")}
        title={getTitle(user)}
      />
    </IconButton>
  </DropdownMenu>
  );
}

// Helpers
function getTitle(user: User) {
  if (user.firstName && user.lastName)
    return `${user.firstName} ${user.lastName}`;
  if (user.name)
    return user.name;

  return undefined;
}

function getAbbreviation(user: User) {
  if (user.firstName && user.lastName)
    return `${user.firstName[0]}${user.lastName[0]}`;
  if (user.firstName)
    return `${user.firstName[0]}${user.firstName[0]}`;
  if (user.name)
    return `${user.name[0]}}`;

  return undefined
}